:host {
  display: block;
  width: 100%;
}

:host([x="xs"]) {
  width: var(--uui-extra-small-spacing);
}

:host([x="sm"]) {
  width: var(--uui-small-spacing);
}

:host([x="md"]) {
  width: var(--uui-medium-spacing);
}

:host([x="lg"]) {
  width: var(--uui-large-spacing);
}

:host([y="xs"]) {
  height: var(--uui-extra-small-spacing);
}

:host([y="sm"]) {
  height: var(--uui-small-spacing);
}

:host([y="md"]) {
  height: var(--uui-medium-spacing);
}

:host([y="lg"]) {
  height: var(--uui-large-spacing);
}
